module.exports = __webpack_public_path__ + "img/logo.adf901e5.png";